import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

import { EmptyState } from 'ui_elements/EmptyState/EmptyState'
import { CardSection } from 'ui_elements/CardSection/CardSection'

const StyledCardSection = styled(CardSection)`
  padding: 0;
  margin: 0;
  margin-top: ${props => (props.marginTop ? '30px' : '0')};
  display: flex;
  justify-content: center;
  a {
    color: ${props => props.theme.colors.primary};
  }
`

const StyledEmptyState = styled(EmptyState)`
  min-height: auto;
  max-width: 850px;
  text-align: left;
  margin: 60px 50px;
  img {
    max-width: none;
    width: ${props => (props.horizontal ? '424px' : '305px')};
  }
  [class*='EmptyStateMessage'] {
    margin: ${props => (props.horizontal ? '20px 25px 0 0' : '20px 0 0 0')};
  }
  [class*='EmptyStateTitle'] {
    margin-top: ${props => (props.horizontal ? '0' : '20px')};
  }
  button {
    margin: 20px 0 0 0;
  }
`

export const CardEmptyState = props => {
  const {
    className,
    header,
    message,
    imageUrl,
    callToAction,
    horizontal,
    marginTop,
    verticalCenter,
    bulletPoints,
    testId
  } = props

  return (
    <StyledCardSection
      marginTop={marginTop}
      className={className}
      data-testid={testId}>
      <StyledEmptyState
        wide
        header={header}
        message={message}
        imageUrl={imageUrl}
        callToAction={callToAction}
        horizontal={horizontal}
        verticalCenter={verticalCenter}
        bulletPoints={bulletPoints}
      />
    </StyledCardSection>
  )
}

CardEmptyState.defaultProps = {
  horizontal: true,
  marginTop: false,
  verticalCenter: false,
  bulletPoints: [],
  testId: undefined
}

CardEmptyState.propTypes = {
  className: PropTypes.string,
  header: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  message: PropTypes.any.isRequired,
  imageUrl: PropTypes.string, // Import the svg and use imageUrl instead
  callToAction: PropTypes.any,
  horizontal: PropTypes.bool,
  marginTop: PropTypes.bool,
  verticalCenter: PropTypes.bool,
  // eslint-disable-next-line react/forbid-prop-types
  bulletPoints: PropTypes.array,
  testId: PropTypes.string
}
